import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Wrapper } from "@cinch-nx/shared-ui";
import React from "react";
export const hasComponent = (componentName, components)=>!!components[componentName];
export const isValidBlock = (block)=>{
    return !!(block === null || block === void 0 ? void 0 : block.component) && !!(block === null || block === void 0 ? void 0 : block._uid);
};
export const ElementFactory = (block, componentMap, props, componentsWithWrapper)=>{
    if (!isValidBlock(block)) {
        if (block) {
            console.error(`Unable to render malformed block as it is missing the 'component' or '_uid' properties:`);
            console.error(block);
        }
        return;
    }
    // component does exist
    if (hasComponent(block.component, componentMap)) {
        if (Array.isArray(componentsWithWrapper) && componentsWithWrapper.includes(block.component)) {
            return /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                children: /*#__PURE__*/ React.createElement(componentMap[block.component], {
                    ...block,
                    ...props
                })
            }, block._uid);
        }
        return /*#__PURE__*/ React.createElement(componentMap[block.component], {
            ...block,
            ...props,
            key: block._uid
        });
    }
    // component doesn't exist yet
    return /*#__PURE__*/ React.createElement(()=>/*#__PURE__*/ _jsxs("div", {
            children: [
                "The component `",
                block.component,
                "` has not been created yet."
            ]
        }), {
        key: block._uid
    });
};
export const checkNotOverLimit = (block, limitedItems)=>!(limitedItems && block.component && Object.prototype.hasOwnProperty.call(limitedItems, block.component) && (limitedItems[block.component]-- ?? 1) <= 0);
